/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js'; 
import "./fin-page-footer.js";
const template = html `
<custom-style>
  <style include="login-styles">
  .mb-margin{
    margin:23%;
} 
    :dir(ltr) .message {
      margin-left: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-right: 4%; */
    }
	
	:dir(rtl) .message {
      margin-right: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-left: 4%; */
    }
	
	.stealthy{
				display: none;
                left: 0;
                margin: 0;
                max-height: 1px;
                max-width: 1px;
                opacity: 0;
                outline: none;
                overflow: hidden;
                pointer-events: none;
                position: absolute;
                top: 0;
                z-index: -1;
            }
    .align-ev-input {
      text-align:left;
      margin-left:16px;
      margin-right:16px;
    }
		:dir(rtl) .stealthy{
			display: none;
			right: 0;
			left: auto;
			margin: 0;
			max-height: 1px;
			max-width: 1px;
			opacity: 0;
			outline: none;
			overflow: hidden;
			pointer-events: none;
			position: absolute;
			top: 0;
			z-index: -1;
        }
    	@media all and (-ms-high-contrast:none)
      	{
		oe-input {
          		--paper-input-container-label: {
              			top: -4px;
            		}
          	}
      	}
          app-dialog{
              --iron-input: {
                display:none !important;
              }
          }

          .center-image{
			  margin-left: 30%;
		  }
          .imgstyle{
            height: 50px;
            width: 315px;
          }
          .descriptionStyle{
            border: 2px solid teal;
            padding: 2px 8px 2px 7px;
            border-radius: 20px;
          }
          .iron-icon-terms{
            height: 30px;
            width: 30px;
          } 
          .font30{
            font-size: 30px;
          }  
        
        /* MB style */
        @media (max-width: 479px){
            .mb-margin{
                margin: 0px !important;
            } 
        }
  </style>
  </custom-style>

  <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
  <div id="main-container" class="light-background full-height">
    <div class="mdl-grid " style="border-bottom:2px solid #dbdfe8;padding: 20px 15px" >
        <div class="mdl-cell mdl-cell--2-col">
            <div class="content-align-vertical-center mb-margin">
                <iron-icon class="iron-icon-style-s cursor-pointer" icon="icons:arrow-back" on-tap="goToBackpage" style="color:#04859C;"></iron-icon> 
                <oe-i18n-msg class="cursor-pointer font-16"  msgid="b_Back" style="color:#04859C" on-tap="goToBackpage"></oe-i18n-msg>
            </div>
        </div>
        <div class="layout mdl-cell mdl-cell--8-col vertical">
        <div class="content-align-center font30 font-weight-bold mdl-cell mdl-cell--12-col">
            <oe-i18n-msg msgid="l_activateSmartAuthentication"></oe-i18n-msg>
        </div>
        <div class="font-18 content-align-center mdl-cell mdl-cell--12-col">
        <oe-i18n-msg msgid="l_activateSmartAuthenticationDes"></oe-i18n-msg>
        </div>
        </div>
        <div class="mdl-cell mdl-cell--2-col">
        </div>
    </div>
    <div class="light-background margin-b-zero mdl-cell mdl-cell--12-col mdl-grid">
        <div class="mdl-cell mdl-cell--1-col">
        </div>
        <div class="mdl-cell mdl-cell--5-col "  >
            <div class="mdl-grid content-align-vertical-center" style="border-bottom:2px solid #dbdfe8;padding: 20px 0px">
                <div class="teal-color" style="margin-right: 10px;">
                    <oe-i18n-msg class="font-18 descriptionStyle" msgid="1" style=""></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <template is="dom-if" if="{{checkTenentIdNBB()}}">
                    <div class="mdl-cell--3-col-phone" >
                        <oe-i18n-msg class="font-18" msgid="l_activateSmartAuthenticationDes1"></oe-i18n-msg>
                    </div>
                </template>
                <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                    <div class="mdl-cell--3-col-phone" >
                        <oe-i18n-msg class="font-18" msgid="l_activateSmartAuthenticationDes1UAE"></oe-i18n-msg>
                    </div>
                </template>
                <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                    <div class="mdl-cell--3-col-phone" >
                        <oe-i18n-msg class="font-18" msgid="l_activateSmartAuthenticationDes1"></oe-i18n-msg>
                    </div>
                </template>
            </div>
            <div class="mdl-grid content-align-vertical-center" style="border-bottom:2px solid #dbdfe8;padding: 20px 0px 20px 40px">
                <div class="horizontal layout">
                    <img src="node_modules/speedboat_ui/images/NBB/Playstore.jpg" class=" " style="padding: 4px 10px 0px 0px;height: 60px;">
                    <img src="node_modules/speedboat_ui/images/NBB/Appstore.jpg" class=" " style="padding: 4px 8px 0px 0px;height: 60px;">
                    <template is="dom-if" if="{{checkTenentIdNBB()}}">
                        <img src="node_modules/speedboat_ui/images/{{tenantId}}/icon.png" class=" " style="height: 65px;">
                    </template>
                </div>
            </div>
            <div class="mdl-grid content-align-vertical-center" style="border-bottom:2px solid #dbdfe8;padding: 20px 0px">
                <div class="teal-color" style="margin-right: 10px;">
                    <oe-i18n-msg class="font-18 descriptionStyle" msgid="2" style=""></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="mdl-cell--3-col-phone" >
                    <oe-i18n-msg class="font-18" msgid="l_activateSmartAuthenticationDes2"></oe-i18n-msg>
                </div>
            </div>
            <div class="mdl-grid content-align-vertical-center" style="border-bottom:2px solid #dbdfe8;padding: 20px 0px">
                <div class="teal-color" style="margin-right: 10px;">
                    <oe-i18n-msg class="font-18 descriptionStyle" msgid="3" style=""></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="mdl-cell--3-col-phone" >
                    <oe-i18n-msg class="font-18" msgid="l_activateSmartAuthenticationDes3"></oe-i18n-msg>
                </div>
            </div>
            <div class="mdl-grid content-align-vertical-center" style="border-bottom:2px solid #dbdfe8;padding: 20px 0px">
                <div class="teal-color" style="margin-right: 10px;">
                    <oe-i18n-msg class="font-18 descriptionStyle" msgid="4" style=""></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <template is="dom-if" if="{{checkTenentIdNBB()}}">
                    <div class="mdl-cell--3-col-phone" >
                        <oe-i18n-msg class="font-18" msgid="l_activateSmartAuthenticationDes4"></oe-i18n-msg>
                    </div>
                </template>
                <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                    <div class="mdl-cell--3-col-phone" >
                        <oe-i18n-msg class="font-18" msgid="l_activateSmartAuthenticationDes4UAE"></oe-i18n-msg>
                    </div>
                </template>
                <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                    <div class="mdl-cell--3-col-phone" >
                        <oe-i18n-msg class="font-18" msgid="l_activateSmartAuthenticationDes4"></oe-i18n-msg>
                    </div>
                </template>
            </div>
            <div class="mdl-cell mdl-cell--12-col"></div>
            <div class="mdl-cell mdl-cell--12-col"></div>
            <div class="mdl-cell mdl-cell--12-col"></div>
            <div class="content-align-vertical-center" style="margin: 25px 0px;">
                <div style="padding-right:10px;">
                    <iron-icon tabindex="0" icon="icons:check-box-outline-blank" class="circle-unchecked cursor-pointer iron-icon-terms" hidden="{{selectedFlag}}" on-tap="_checkUncheck"></iron-icon>
                    <iron-icon tabindex="0" icon="check-box" class="circle-checked cursor-pointer icon-color iron-icon-terms" hidden="{{!selectedFlag}}" on-tap="_checkUncheck"></iron-icon>
                </div>
                <template is="dom-if" if="{{checkTenentIdNBB()}}">
                    <div class="font-16">
                        <oe-i18n-msg msgid="l_activateSmartAuthenticationDeclaration"></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;
                    </div> 
                </template>
                <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                    <div class="font-16">
                        <oe-i18n-msg msgid="l_activateSmartAuthenticationDeclarationUAE"></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;
                    </div> 
                </template>
                <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                    <div class="font-16">
                        <oe-i18n-msg msgid="l_activateSmartAuthenticationDeclaration"></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;
                    </div> 
                </template>
                <div class="font-16 font-weight-700 mdl-cell mdl-cell--2-col-phone teal-color margin-l-zero margin-r-zero" style="padding-right: 5px; width:100px">
                <a href="https://www.nbbonline.com/" target="_blank" style="color: #00839B !important;text-decoration:none;"><oe-i18n-msg msgid="l_needHelp"></oe-i18n-msg></a>
                </div>
                <div class="font-16 font-weight-700 mdl-cell mdl-cell--2-col-phone teal-color margin-l-zero" style="width:100px">
                <a href="https://www.nbbonline.com/" target="_blank" style="color: #00839B !important;text-decoration:none;"><oe-i18n-msg msgid="l_contactUs"></oe-i18n-msg></a>
                </div>
                <div>
                </div>
            </div>
            <div class="mdl-cell--6-col" >
            <paper-button class="mdl-cell--5-col primary-button" on-tap="showCrontoImage" disabled={{!selectedFlag}} style="width: -webkit-fill-available;height: 40px;">
					 <oe-i18n-msg msgid="l_proceed"></oe-i18n-msg>
				</paper-button>
            </div>

            
        </div>
        <template is="dom-if" if="{{!phone}}">
        <div class="mdl-cell mdl-cell--6-col content-align-center" style="padding:10px;">
            <template is="dom-if" if="{{checkTenentIdNBB()}}">
                <div class="mdl-cell--12-col-desktop" width="500px" height="400px" >
                    <div class="font-weight-light primary-light-text-xxxl  text-align-left content-align-center">
                        <img width="400px" height="400px" src="node_modules/speedboat_ui/images/{{tenantId}}/icon.png">
                    </div>
                </div>
            </template>
            <!--<template is="dom-if" if="{{checkTenentIdNBB()}}">
                <video id="nbbVideo" width="500px" height="400px" 
                    controls="controls"/> 
                    <source  src="documents/videos/NBB/BOB_Video_1.mp4" 
                        type="video/mp4"> 
                </video>
            </template>-->
            <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                <video id="nbbVideo" width="500px" height="400px" 
                    controls="controls"/> 
                    <source  src="node_modules/speedboat_ui/images/NBB/finacle_v0.1.1.mp4" 
                        type="video/mp4"> 
                </video>
            </template>
            <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                <div class="mdl-cell--12-col-desktop" width="500px" height="400px" >
                    <div class="font-weight-light primary-light-text-xxxl  text-align-left content-align-center">
                        <img width="400px" height="400px" src="node_modules/speedboat_ui/images/{{tenantId}}/icon.png">
                    </div>
                </div>
            </template>
        </div> 
        </template>
    </div>
    <div class="">
        <div class=" light-background" style="height: 35%;padding-left: 3%;">
            <!--<div class="content-align-center font-16 mdl-cell mdl-cell--12-col teal-color" style="padding-top: 2%;" on-tap="resetMpinFunction">
                <oe-i18n-msg msgid="l_resetMpinAndAdvancedSecurityOptions" class="cursor-pointer" style="text-decoration: underline;"></oe-i18n-msg>
            </div>-->
        </div>
        <div class="mdl-cell--12-col mdl-grid light-background"></div>
        <!-- component for the footer -->
        <fin-page-footer/>
    </div>

  </div> 

  `;
Polymer({
    is: 'fin-auth-playstore',
    _template: template,
    behaviors: [corpBehaviours.appCommonBehaviour],
    properties: {
        wrapperValue: {
            type: String,
            value: '',
            notify: true
        },
        showError: {
            type: Boolean,
            value: false,
            notify: true,
            observer: "toggleErrorMessage"
        },
        errorMessage: {
            type: String,
            value: "Minimum 6 and maximum 12 characters",
            notify: false
        },
    showCrontoImageFlag: {
	      type: Boolean,
	      value: false,
	      notify: true
    },
        pattern: {
            type: String,
            value: "((?! ).)*",
            notify: false
        },
        minlength: {
            type: Number,
            value: 6,
            notify: false
        },
        maxlength: {
            type: Number,
            value: 12,
            notify: false
        },
        label: {
            type: String,
            value: "Transaction Password",
            notify: false
        },
        wrapperValueInput: {
            type: String,
            value: '',
            notify: true,
            observer: 'inputValueChanged'
        },
        isvalid: {
            type: Boolean,
            value: true,
            notify: true
        },
        required: {
            type: Boolean,
            notify: true
        },
        selectedFlag: {
            type: Boolean,
            notify: true,
            value: false
        },
        selectedLoginPage:{
            type:Number,
            notify:true,
            observer:'_setSelectedDefault'
        },
        selectedPage: {
            type: Number,
            notify: true 
        },
        fromPlaystore: {
            type: Boolean,
            notify: true,
            value: false
        },
        tenantId: {
            type: String,
            value: sessionStorage.getItem("tenantId")
        }
    },
    ready: function() {
        this.toggleErrorMessage();
    },
    inputValueChanged: function() {

        var self = this;
        if (this.wrapperValue.trim().length > 0) {
            this.isvalid = true;
        } else {
            this.isvalid = false;
        }
        if (self.wrapperValueInput.trim().length > 0)
            self.wrapperValue = sbEncrypt.encrypt(self.wrapperValueInput);
        else
            self.wrapperValue = "";
    },
    attached: function() {
        // this.$$("#fmpwd2").value = "dummy";
        // this.$$("#pwd1").value = "dummy";
  },
  showCrontoImage : function () { 
      if (this.shadowRoot.getElementById('nbbVideo')) {
          var vid1 = this.shadowRoot.getElementById('nbbVideo');
          vid1.pause();
      }
	  this.showCrontoImageFlag= true;
      this.selectedLoginPage=1
  },
  toggleErrorMessage: function () {
    if (this.showError) {
      this.$.tpInput.pattern = this.pattern;
      this.$.tpInput.errorMessage = this.errorMessage;
      this.$.tpInput.preventInvalidInput = true;
      this.$.tpInput.autoValidate = true;
      this.$.tpInput.minlength = 6;
      this.$.tpInput.maxlength = 12;
    } /*else {
      this.$.tpInput.removeAttribute("pattern");
      this.$.tpInput.removeAttribute("minlength");
      this.$.tpInput.removeAttribute("maxlength");
      this.$.tpInput.removeAttribute("errorMessage");
      this.$.tpInput.preventInvalidInput = false;
      this.$.tpInput.autoValidate = false;
    } */
  },
  
	_checkUncheck() {
		if (this.selectedFlag == false) {
			this.selectedFlag = true;
		}
		else {
			this.selectedFlag = false;
		}
	}    ,
  goToBackpage(){
      if (this.shadowRoot.getElementById('nbbVideo')) {
          var vid1 = this.shadowRoot.getElementById('nbbVideo');
          vid1.pause();
      }
      this.selectedFlag = false;
    this.selectedPage=0;
    this.fromPlaystore=true;
  },
  _setSelectedDefault(){
    if(this.selectedLoginPage==0){
        this.selectedFlag = false;
    }
  }
});